import React from 'react'

const Meal = props => {
  const { qty, name, img } = props
  return (
    <div className="selected_meal">
      <div className="qty">
        <span>{qty}x</span>
      </div>
      <div className="pic">
        <img src={img} alt="meal pic" />
      </div>
      <div className="name">
        <span>{name}</span>
      </div>
    </div>
  )
}

const MyMeals = props => {
  const { products } = props

  return (
    !!products.length && (
      <div className="cookunity__checkout_meals">
        <h1 className="title">My Meals</h1>

        <div className="meals_container">
          {products.map(product => {
            return (
              <Meal
                key={product.id}
                qty={product.qty}
                name={product.mealFullName}
                img={product.mealImage}
              />
            )
          })}
        </div>
      </div>
    )
  )
}

export default MyMeals



// WEBPACK FOOTER //
// ./src/modules/Checkout/Meals/Meals.jsx